import type { IBaseControlSetting, EControlType } from '~/presentation/reports/common/type';
import type { IItemSelectorConfig } from '../../type';

import { SectionCardContent } from './SectionCardContent';
import { Box } from '@shopify/polaris';

export interface IControlSectionCard extends IBaseControlSetting {
  type: EControlType.SECTION_CARD;
  config?: IItemSelectorConfig;
}
export const SectionCard: React.FC<IControlSectionCard> = (props) => {
  return (
    <Box
      background="bg-surface-secondary"
      paddingInline="200"
      paddingBlock="150"
      borderStartStartRadius="200"
      borderStartEndRadius="200"
    >
      <SectionCardContent {...props} />
    </Box>
  );
};
